import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Dialog, DialogContent } from './Dialog/Dialog';
import { Icons } from './BootstrapComponents';
import './VideoPreviewModal.scss';

export default function VideoPreviewModal(props) {
  const {
    open = false,
    videoUrl = '',
    title = 'Просмотр видео',
    onClose = () => {},
  } = props;

  const sourceUrl = useMemo(() => {
    if (!open || !videoUrl) {
      return '';
    }

    return `${videoUrl}${videoUrl.includes('?') ? '&' : '?'}_=${Date.now()}`;
  }, [open, videoUrl]);

  return (
    <Dialog
      className="video-preview-modal"
      onClose={onClose}
      size="xl"
      open={open}
    >
      <DialogContent className="video-preview-modal-content" onMouseDown={event => event.stopPropagation()}>
        <div className="video-preview-modal-header">
          <div className="video-preview-modal-title">{title}</div>
          <Icons width={14} height={14} customIcon icon="clear" className="video-preview-modal-close" onClick={onClose} />
        </div>
        <div className="video-preview-modal-body">
          {sourceUrl ? (
            <video
              key={sourceUrl}
              className={classNames('video-preview-modal-video', { empty: !sourceUrl })}
              controls
              autoPlay
              playsInline
              preload="metadata"
            >
              <source src={sourceUrl} type="video/mp4" />
              <track kind="captions" label="Без субтитров" srcLang="ru" />
            </video>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
